// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ManagerFragment = { __typename?: 'Employee' } & Pick<Types.Employee, 'id' | 'status'> & {
    generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
      Types.EmployeeGeneralInformation,
      'preferredFullName' | 'nameInLocalLanguage'
    >;
    currentMainContract: Types.Maybe<
      { __typename?: 'EmployeeContract' } & { company: { __typename?: 'Company' } & Pick<Types.Company, 'name'> }
    >;
    currentPosition: Types.Maybe<
      { __typename?: 'EmployeeJobHistory' } & Pick<Types.EmployeeJobHistory, 'level'> & {
          businessUnit: { __typename?: 'BusinessUnit' } & Pick<Types.BusinessUnit, 'name'>;
        }
    >;
  };

export type GetManagerQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetManagerQuery = { __typename?: 'Query' } & {
  employee: Types.Maybe<{ __typename?: 'Employee' } & ManagerFragment>;
};

export const ManagerFragmentDoc = /*#__PURE__*/ gql`
    fragment Manager on Employee {
  id
  status
  generalInformation {
    preferredFullName
    nameInLocalLanguage
  }
  currentMainContract {
    company {
      name
    }
  }
  currentPosition {
    businessUnit {
      name
    }
    level
  }
}
    `;
export const GetManagerDocument = /*#__PURE__*/ gql`
    query GetManager($id: ID!) {
  employee(id: $id) {
    ...Manager
  }
}
    ${ManagerFragmentDoc}`;

/**
 * __useGetManagerQuery__
 *
 * To run a query within a React component, call `useGetManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetManagerQuery(
  baseOptions: Apollo.QueryHookOptions<GetManagerQuery, GetManagerQueryVariables> &
    ({ variables: GetManagerQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManagerQuery, GetManagerQueryVariables>(GetManagerDocument, options);
}
export function useGetManagerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetManagerQuery, GetManagerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManagerQuery, GetManagerQueryVariables>(GetManagerDocument, options);
}
// @ts-expect-error
export function useGetManagerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetManagerQuery, GetManagerQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetManagerQuery, GetManagerQueryVariables>;
export function useGetManagerSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManagerQuery, GetManagerQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetManagerQuery | undefined, GetManagerQueryVariables>;
export function useGetManagerSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManagerQuery, GetManagerQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetManagerQuery, GetManagerQueryVariables>(GetManagerDocument, options);
}
export type GetManagerQueryHookResult = ReturnType<typeof useGetManagerQuery>;
export type GetManagerLazyQueryHookResult = ReturnType<typeof useGetManagerLazyQuery>;
export type GetManagerSuspenseQueryHookResult = ReturnType<typeof useGetManagerSuspenseQuery>;
